import React from 'react';
import { useParams, Redirect } from 'react-router-dom';
import { useScrollToTop } from "./hooks/useScrollToTop";
import { useSetPageMeta } from '@applyboard/ui-utils';
import { useScholarship } from "../../data/useScholarship";
import { ScholarshipPageContextProvider } from "./contexts";
import { ScholarshipPageLayout } from "./components/ScholarshipPageLayout";
import { LoadingPage } from "./components/LoadingPage";
import { PageWrapper } from "./components/PageWrapper";
import { globalStyles } from "./globalStyles";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export function ScholarshipPage() {
  useScrollToTop();
  var _useParams = useParams(),
    idOrSlug = _useParams.scholarship_id;
  var _useScholarship = useScholarship(idOrSlug),
    scholarship = _useScholarship.data,
    isScholarshipLoading = _useScholarship.isLoading,
    scholarshipError = _useScholarship.error;
  useSetPageMeta({
    title: (scholarship === null || scholarship === void 0 ? void 0 : scholarship.title) || 'Scholarship'
  });
  if (scholarshipError) {
    // show 404 not found page
    return _jsx(Redirect, {
      to: "/404"
    });
  }
  if (isScholarshipLoading || !scholarship) {
    return _jsx(LoadingPage, {});
  }
  return _jsx(PageWrapper, {
    children: _jsxs(ScholarshipPageContextProvider, {
      scholarship: scholarship,
      children: [_jsx("style", {
        children: globalStyles
      }), _jsx(ScholarshipPageLayout, {})]
    })
  });
}